import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DialogWidth, RefModelNode} from '@q9elements/ui-kit/common';
import {filter} from 'rxjs/operators';
import {EditModelDialogComponent} from '../dialogs/edit-model-dialog/edit-model-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class InternalDialogService {
  constructor(private dialog: MatDialog) {}

  public openEditNode(node: RefModelNode) {
    return this.dialog
      .open(EditModelDialogComponent, {
        width: DialogWidth.MD,
        data: node
      })
      .afterClosed()
      .pipe(filter(Boolean));
  }
}
